import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Label from '../../atoms/label/label';
import backIcon from '../../assets/images/backIcon.svg';
import { useLocation } from 'react-router-dom';
import './privacy.scss';
import queryString from 'query-string';

const privacyPolicy = {
  safeguard_heading: 'SAFEGUARDING YOUR PRIVACY',
  safeguard_point1:
    'Your privacy matters to Ola Electric Mobility Private Limited and its Subsidiaries and Affiliates (the “Company”, “we”, “Ola Electric”, or “us”). This Privacy Policy explains how we collect, process, use, share and protect information about you. It also tells you how you can access and update your information and make certain choices about how your information is used.',
  safeguard_point2:
    'The Privacy Policy covers both “online” (e.g., web and mobile services/App however accessed and/or used, whether via personal computers, mobile devices, mobile application or otherwise) and “offline” (e.g., collection of data through mailings, telephone, or in person) activities owned, operated, provided, or made available by the Company. Our “online” and “offline” activities, in relation to sale of electric vehicles or other services, are collectively referenced as the “Products and Services”. This Privacy Policy also applies to your use of (a) our Products or Services; and (b) interactive features or downloads that: (i) we own or control; (ii) are available through or using our Products or Services; or (iii) interact with our Products and post or incorporate this Privacy Policy.',
  safeguard_point3:
    'To aid convenience to the users, the Products and Services rendered by Ola Electric through online medium are also accessible to you through a single sign on through Ola Cabs account/application owned by ANI Technologies Private Limited (“ANI”). Single sign on makes it easy to centrally manage access to these accounts and provide users with single sign-on access to their assigned accounts from one place. You further understand and consent to the exchange and sharing of information including but not limited to the heads of information set out in Clause 2 below, between us and ANI in order to provide the Products and Services to you.',
  safeguard_point4:
    'UPON ACCEPTANCE OF THIS PRIVACY POLICY OR BY CONTINUING TO USE THE WBSITE OR APP, YOU AGREE TO THE TERMS OF THIS PRIVACY POLICY. Please review the following carefully so that you understand our privacy practices. If you do not agree to this Privacy Policy, do not accept the same or use our Products or Services. If you have questions about this Privacy Policy, please contact us through email address provided in the Privacy Policy.  ',

  information_header: 'WHAT INFORMATION DO WE COLLECT?',
  information_subheader: 'INFORMATION YOU PROVIDE TO US',
  information_points_title:
    'We may collect the following information belonging to you from you or through Ola Electric:',
  information_bullets_point: [
    'Full name;',
    'E-mail address;',
    'Date of birth;',
    'Location information, including the GPS location of (a) any person placing an order through Ola Electric website or mobile application or any other mode; (b) while using location based services through Products and Services; and (b) addresses provided for providing the Products or Services by us;',
    'Address (including city or town); ',
    'Billing and shipping address;',
    'Phone numbers;',
    'Account login credentials and password;',
    'IP addresses; ',
    'Details of the Products or Services ordered including pricing;',
    'Date of purchase of Products or Services;',
    'Driving license no. and expiry date;',
    'Telematics data such as performance, operations, performance, usage of Products;',
    'Payment information and history (excluding payment details that shall be collected and processed by an authorized payment service provider, which we do not collect);',
    'Credit card or debit card number including expiry date;',
    'Any device and device identifier information as may be deemed necessary.',
    'Any other additional information as specified below.',
  ],
  information_after_1_bullet:
    'We use information collected from you or third party sources to provide you with our Products or Services. We may also use information collected about you to: (i) administer your Account; (ii) respond to and resolve customer service requests; (iii) obtain your feedback regarding our Products and Services; (iv) improve the Products and Services; (iv) analyze user behaviour, on an aggregated or anonymized basis only; (v) run marketing campaigns or other engagement activities from time to time; and (vi) provide you certain Services. We may also collect information about your use of our Products and Services and performance/operation information.',
  information_2_bullet_title:
    'We collect the above information in the following ways:',
  information_2_bullet_points: [
    ' When you create an Ola Electric user account and provide us your information (the “User Account”);',
    'When you visit our website (the “Website”);',
    `When you use our software application including mobile application (the "App");`,
    ' When you book a test ride;',
    ' When you pre-order or purchase our Products or Services;',
    'When you set up and drive any of our Products;',
    'When we communicate or undertake activities such as referrals, affiliates, brand champion etc.',
  ],

  user_account_header: 'USER ACCOUNT',
  user_account_bullet_title:
    'To make use of our Products or Services you will receive a User Account. To set up your User Account we collect following information from you:',
  user_acc_bullet_point: ['Email ID', 'Full name', 'Phone number'],

  user_acc_after_bullet_1:
    'Depending on the Products and Services you desire, more data will be linked to your User Account.',
  user_acc_after_bullet_2: '[Reference to Single Sign On privacy notice above]',

  web_app_header: 'WEBSITE & APP',
  web_app_text:
    'When you visit our Website or App, usage data is collected automatically through the Website or App. Such usage data can include the type of device, the IP address, and the current location. We also collect information about your click and search behaviour. We use this data to adjust the Website or App or enhance the features of our Products and Services, for example, to make the App layout more convenient to you, and to change the order of search results, to design certain pages differently. We collect usage data by using various types of cookies (small pieces of data stored in your device) and other tracking tools. We collect such data with your consent. Consent can be withdrawn at any time. The retention period of cookies is limited and differs per cookie. We may collect information through cookies for the purposes of advertising and analytics. You may disable cookie collection through your browser or Device but this may result in some features of the Services not functioning properly and we will not be able to send customized and relevant communication or promotional messages to you. Also, while accessing certain features of our Website/App, where required by the applicable laws, we may also request your permission to access, phone book, SMS, camera, device storage, call functionally etc. We also collect your location, when you search for or request installation of charging stations.',
  test_ride_header: 'TEST RIDE',
  test_ride_text:
    'If you book a test ride, we need the following information to organize your ride:',
  test_ride_bullet_point: [
    ' Email ID',
    'First and last name',
    'Phone number',
    'Driving license number and expiry date',
    'Any other photo ID proof, if required',
  ],
  preorder_purchase_header: 'PRE-ORDER AND PURCHASE',
  preorder_purchase_text:
    'If you pre-order or purchase our Products or Services on our Website or App or any other mode (such as referrals, affiliate, brand champions etc.), we ask you to fill in the details of your order. We need this data to send you an order confirmation, to process your payment, to keep you up to date with respect to your order and to deliver your order to you.',
  preorder_purchase_bullet_title:
    'The configuration and purchase price of your Product or Services availed;',
  preorder_purchase_bullet_points: [
    ' Date of purchase;',
    ' Name of user',
    ' Date of birth;',
    ' Driving License Number;',
    ' Driving License Expiry Date;',
    '  Income Tax PAN Number;',
    ' Delivery Address.',
  ],
  driving_header: 'DRIVING OUR PRODCUTS',
  driving_text1: 'Location',
  driving_text2:
    'To provide you with location-based services, such as your GPS navigation, we collect your real time location to know where you are. We only collect your live location if you specify in your settings that you would like us to “collect” or “always collect” your location. If you have not specified this, we will not collect your live location unless you are driving your Product. We will also collect historic location data, such as your favorite, saved, pinned or searched locations to improve the functionality of your GPS navigation. You may turn off location sharing. However, please note that without the ability to collect your location we will not be able to provide you with location-based services or certain other features of our Products and Services will not be available.',
  driving_text3: 'Other telematics data collected by the scooter',
  driving_text4:
    'To further improve your Product and safety, to facilitate the (helpdesk) servicing of your Product and to give you insight on your driving behaviour, we will collect certain telematics data but not limited to the performance, usage, operation, and condition of your Product, including your vehicle identification number; battery serial number; repair history, speed information; odometer readings; duration (time and date) of travel; motor status, charge status, battery use management information; battery charging history; lock status, network status, light status, BCM status, drive train status, electrical system functions; software version information; infotainment system data; safety-related data and other data to assist in identifying issues and analyzing the performance of your Product.',
  driving_text5:
    'We collect such information either in person (such as during a service appointment) or via remote access or through App. Also, collection of this data enables you to learn more about your driving behaviour. For example: the energy-efficiency of your driving behaviour. We are able to connect to your Product to diagnose and resolve issues with it, and this process may result in access to personal settings in your Product (such as contacts or navigation history).',
  use_of_collection_header: 'USE OF COLLECTED INFORMATION',
  use_of_collection_bullet_points: [
    'We use your information to closely monitor which features of the Product/App/Website or which Services are used most, to allow you to view your service/purchase history, ratings, and to determine which features we need to focus on improving, including usage patterns to determine where we should offer or focus services, features and/or resources.',

    'We use your Internet Protocol (IP) address to help diagnose problems with our computer server, and to administer our website(s)/App/. Your IP address is used to help identify you, but contains no personal information about you.',

    'We will share promotional updates and communications unless you have specifically opted out of the same, where applicable, in our legitimate interest. We will use your personal information for marketing analysis and to provide you with promotional updates and communications by email, telephone, text messages, in-application messages and/or push messages about our Products and/or Services. We may also share information with third-party social media and other partner platforms in order to provide you with promotional update communications.',

    'The types of communications we may send under clause 8.3 above also include information regarding Ola Electric’s new Products and Services, features, newsletters, research and development efforts, surveys, studies, news, updates, and events. We may also personalize the communications we send based on your use of the App or Website, such as your frequently visited locations to provide you with offers, your existing user preferences and settings, and feedback you may have provided to us. You can object to further marketing at any time in your profile settings or by selecting the “unsubscribe” link at the end of our marketing and promotional update communications to you.',

    'We may also use your information to (a) enable you to participate in a variety of the Ola Electric features such as contests or other promotions; (c) contact you with regard to your use/interest in the Products and Services and in our discretion, changes to the policies with respect to Products and Services; (d) for internal business purposes; (e) for inclusion in our data analytics; and (f) for purposes disclosed at the time you provide your information or as otherwise set forth in this Privacy Policy.',

    'We may also collect information during offline interactions, such as when you visit an Ola Electric store or repair facility, attend one of our events or sign up for a test drive.',

    'Whatever contacting channel you choose, we will only process the data that is necessary for us to get back to you through that specific channel and the data needed to be able to undertake other necessary actions in response to your request.',

    'We will send you strictly any Products or Services-related or announcements on rare occasions when it is necessary to do so. For instance, if our any of our services are temporarily suspended for maintenance, we might send you an email. If you do not wish to receive them, you have the option to unsubscribe from the same.',

    'We use that geo-location information for various purposes, including for you to be able to view the Ola Electric stores, charging stations, repair facilities and other Services relating to the Products in your area that are close to your location.',

    "We may use the information collected from you for targeted advertising. This involves using information collected on an individual's web or mobile browsing behaviour such as the pages they have visited or the searches they have made. This may also involve the Services procured for the Products. This information is then used to select which advertisements should be displayed to a particular individual on sites other than our site(s). The information collected is only linked to an anonymous cookie ID (alphanumeric number); it does not include any information that could be linked back to a particular person, such as their name, address or credit card number.",
  ],
  updates_comm_header: 'UPDATES AND COMMUNICATIONS',
  updates_comm_text1:
    'We will share promotional updates and communications with your consent or, where applicable, in our legitimate interest. Where permitted in our legitimate interest, we will use your personal information for marketing analysis and to provide you with promotional updates and communications by email, telephone, text messages, in-application messages and/or push messages about our products and/or services. We may also share information with third-party social media and other partner platforms in order to provide you with promotional update communications. ',
  updates_comm_text2:
    'The types of communications we may send include information regarding Ola’s services, features, research and development efforts, surveys, studies, news, updates, and events. We may also personalise the communications we send based on your use of the App or Website, such as your frequently visited locations to provide you with offers, your existing user preferences and settings, and feedback you may have provided to us. You can object to further marketing at any time in your profile settings or by selecting the “unsubscribe” link at the end of our marketing and promotional update communications to you.',
  updates_comm_text3:
    'We may also collect information during offline interactions, such as when you visit a Etergo store or repair facility, attend one of our events or sign up for a test drive, ',
  updates_comm_text4:
    'Whatever contacting channel you choose, we will only process the data that is necessary for us to get back to you through that specific channel and the data needed to be able to undertake other necessary actions in response to your request. ',
  retension_header: 'RETENTION',
  retension_text1:
    'We will retain information (including geo-location) we collected for as long as your account is with Ola Electric is active and for the period necessary to fulfil the purposes outlined in this Privacy Policy except in case a longer retention period is required or permitted by law. Even after your account is terminated or you have discontinued the use of Products or Services, we will retain your information (including geo-location, Product details, and service/transaction history) as needed to comply with our legal and regulatory obligations, resolve disputes, conclude any activities related to cancellation of an account, investigate or prevent fraud and other inappropriate activity, to enforce our agreements, and for other business reason. After a period of time, your data may be anonymized and aggregated, and then may be held by us as long as necessary for us to provide our services effectively, but our use of the anonymized data will be solely for analytic purposes. When the information is no longer necessary for these purposes, we keep it in a form that does not identify you or delete it.',
  sharing_header: 'SHARING DATA WITH OTHERS',
  sharing_data: [
    'We do not sell, share, rent or trade the information we have collected about you, other than as disclosed within this Privacy Policy or at the time you provide your information. Following are the situations when information may be shared.',
    'Only when necessary',

    'We may share your information with our service providers and business partners or Ola Electric affiliates (such as our parent company Ola Electric Mobility Private Limited and companies that are part of the wider Ola group or ANI).',
    'Third Parties providing Services on our behalf',

    'We make use of third-party service providers to help us provide our Products and Services to you or to provide or perform certain aspects of Services provided on our behalf and to run our Website and App. For example, we share your personal data with third party service providers for the purposes of hosting our Website, processing your payment, monitoring and analyzing web traffic, advertising, user database management, marketing and behavioral targeting, registration and authentication and managing contacts, providing customer support, engaging in anti-fraud and security measures, providing geo-location information for the Services, perform technical Services (e.g. without limitation, maintenance services, data base management, web analytics, providing updates and improvement of features in our Products and Services). These third parties will have access to your information, to only carryout the services they are performing for you. Each of these third parties are required to ensure the same level of data protection as us and are obligated not to disclose or use your information for any other purpose.',
    'Analytics third party service providers may set and access their own cookies, web beacons and embedded scripts on your device and they may otherwise collect or have access to information about you, including non-personally identifiable information.',
    'We use a third party hosting provider who hosts our support section of our App. Information collected within this section by such third party is governed by our Privacy Policy.',

    'When you agree to receive information from Third Parties.',

    'You may be presented with an opportunity to receive information and/or marketing offers directly from third parties. If you do agree to have your information shared, your information will be disclosed to such third parties and all information you disclose will be subject to the privacy policy and practices of such third parties. We are not responsible for the privacy policies and practices of such third parties and, therefore, you should review the privacy policies and practices of such third parties prior to agreeing to receive such information from them. If you later decide that you no longer want to receive communication from a third party, you will need to contact that third party directly.',

    'Contests and Promotions',

    'We may offer promotions through the Products and Services that may require registration. By participating in a promotion, you are agreeing to official rules that govern that promotion, which may contain specific requirements of you, including, allowing the sponsor of the promotion to use your name and/or likeness in advertising or marketing associated with the promotion. If you choose to enter a promotion, you agree that your information may be disclosed to third parties or the public in connection with the administration of such promotion, including, in connection with winner selection, prize fulfilment, and as required by law or permitted by the promotion’s official rules, such as on a winners list.',

    'Administrative and Legal Reasons',

    'We cooperate with Government and law enforcement officials and private parties to enforce and comply with the law. Thus, we may access, use, preserve, transfer and disclose your information (including, IP address, Product or device information or geo-location data), to Government or law enforcement officials or private parties as we reasonably determine is necessary and appropriate: (i) to satisfy any applicable law, regulation, subpoenas, Governmental requests or legal process; (ii) to protect and/or defend the terms and conditions for online and mobile services or other policies applicable to any online and mobile services, including investigation of potential violations thereof; (iii) to protect the safety, rights, property or security of Ola Electric, our Services or any third party; (iv) to protect the safety of the public for any reason; (v) to detect, prevent or otherwise address fraud, security or technical issues; and /or (vi) to prevent or stop activity we may consider to be, or to pose a risk of being, an illegal, unethical, or legally actionable activity.',

    'When you share information pertaining to Products or Services:',

    'Your information may be collected and shared with third-parties if there is content from the App that you specifically and knowingly upload to, share with or transmit to an email recipient, online community, website, or to the public, e.g. uploaded photos, posted reviews or comments, or information about the Products or Services availed that you choose to share with others through features which may be provided. This uploaded, shared or transmitted content will also be subject to the privacy policy of the email, online community website, social media or other platform to which you upload, share or transmit the content.',

    'Business Transfer',

    'We may share your information, with our parent, subsidiaries and affiliates for internal reasons. We also reserve the right to disclose and transfer all such information: (i) to a subsequent owner, co-owner or operator of the Services or applicable database; or (ii) in connection with a corporate merger, consolidation, restructuring, the sale of substantially all of our membership interests and/or assets, business or stake or other corporate change, including, during the course of any due diligence process. Each of these third parties are required to ensure the same level of data protection as us and are obligated not to disclose or use your information for any other purpose.',

    'Co-Branded Services',

    'Certain aspects of the services may be provided to you in association with third parties (“Co-Branded Services”) such as sponsors and charities, and may require you to disclose your information to them. Such Co-Branded Services will identify the third party. If you elect to register for products and/or services through the Co-Branded Services, you shall have deemed to consent to providing your information to both us and the third party. Further, if you sign-in to a Co-Branded service with a username and password obtained through our Products and Services, your information may be disclosed to the identified third parties for that Co-Branded service and will be subject to their posted privacy policies.',

    'Payment processing',

    'Payments are made through our payment gateway providers. You will be providing payment instrument details (including credit or debit card information) directly to our payment gateway providers and we will not be collecting details regarding your debit or credit or other payment instruments. Information which you supply to our payment service providers is not within our control and is subject to the respective providers’ own privacy policy and terms and conditions.',
    'Cross Border Transfers',

    'The personal information that we collect from you may be transferred to, and stored at, a destination outside your country. Those countries may not have the same data protection laws as the country in which you initially provided that information. ',
  ],

  sharing_bullet_title:
    'We may transfer your personal information outside your country:',
  sharing_bullet_points: [
    ' In order to enable us to provide services to you and fulfil our contract with you. ',
    ' Where we are legally required to do so.',
    'In order to facilitate the operation of our group of businesses, where it is in our legitimate interests and we have concluded these are not overridden by your rights.',
  ],
  sharing_last_text:
    'Where your information is transferred outside your country, we will take all steps reasonably necessary to ensure that your data is subject to appropriate safeguards, such as relying on a recognized legal adequacy mechanism, and that it is treated securely and in accordance with this privacy policy.',

  thirdparty_header: 'THIRD PARTY CONTENT AND LINKS TO THIRD PARTY SERVICES',
  thirdparty_text:
    'Our Website, App or services we provide may contain content that is supplied by a third party, and those third parties may collect our Website/App or Product or Services usage information. In addition, when you are using our Website/App/Products or Services, you may be directed to other sites or applications that are operated and controlled by third parties that we do not control. We are not responsible for the privacy practices employed by any of these third parties. For example, if you click on a banner advertisement, the click may take you away from one of our App/ Website onto a different website or application. These other sites may send their own cookies to you, independently collect data or solicit information and may or may not have their own published privacy policies. We encourage you to note when you leave our App/Website and to read the privacy statements of all third party sites or applications before submitting any information to third parties. In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.',

  social_media_header: 'SOCIAL MEDIA FEATURES AND WIDGETS',
  social_media_text:
    'Our Website or App may include social media features, such as the Facebook Like button, and widgets such as a “Share This” button, or interactive mini-programs. These features may collect your IP address, photograph, which page you are visiting on our online or mobile services, and may set a cookie to enable the feature to function properly. Social media features and widgets are either hosted by a third party or hosted directly on our online Services. Your interactions with these features and widgets are governed by the privacy policy of the company providing them.',
  security_header: 'SECURITY',
  security_text:
    "We do everything in our power to keep your personal data safe. We ensure the confidentiality and security of your information implementing reasonable precautions and follow industry best practices to ensure that information provided by you is not inappropriately lost, misused, accessed, disclosed, altered or destroyed. However, as effective as encryption technology is, no security system is impenetrable. We cannot guarantee the security of our databases, nor can we guarantee that information you supply won't be intercepted while being transmitted to us over the internet or wireless communication, and any information you transmit to Ola Electric you do at your own risk. We recommend that you not disclose your password to anyone. Since all our accounts are password protected, you should be the only person with access to your account. If your login information is stolen or used without your permission, please make sure to contact us immediately on the email id given in this Privacy Policy so we can secure your account.",
  change_policy_header: 'CHANGES TO THIS PRIVACY POLICY',
  change_policy_text:
    'From time to time, we may update this Privacy Policy to reflect changes to our information practices. Any changes will be effective immediately upon the posting of the revised Privacy Policy. If we make any material changes, we will notify you by email (sent to the e-mail address specified in your account) or by means of a notice on the services prior to the change becoming effective. We encourage you to periodically review this page (including last update date of this Privacy Policy) for the latest information on our privacy practices.',
  gre_header: 'GRIEVANCES',
  gre_text:
    'If you have any concerns or questions in relation to this Privacy Policy, you may address them by writing to our Grievance Office at ',
  gre_text_email: 'legal@olaelectric.com',

  other_rights: 'OTHER RIGHTS',

  other_right_data: [
    'If you are located in the European Economic Area or the United Kingdom, the following rights may apply to you based on the applicable laws:',

    'Withdraw your consent. You have the right to withdraw consent where you have previously given your consent to the processing of your data. Please note that withdrawing consent has no impact on earlier processing of your personal data on such basis and does not prevent us from invoking another available legal basis for the processing of such personal data.',

    'Object to processing of your data. You have the right to object to the processing of your data if the processing is carried out on a legal basis other than consent. Where your personal data is processed for the purposes of the legitimate interests pursued by us, you may object to such processing by providing a ground related to your particular situation to justify the objection. When your data is processed for direct marketing purposes, you can object to that processing at any time without having to provide any justification.',

    'Access your data. You have the right to learn if your data is being processed by us, obtain disclosure regarding certain aspects of the processing and obtain access to the personal data.',

    'Verify and seek rectification. You have the right to verify the accuracy of your data and ask for it to be updated or corrected.',

    'Restrict the processing of your data. You have the right, under certain circumstances, to restrict the processing of your data. In this case, we will not process your data for any purpose other than storing it.',

    'Have your personal data deleted or otherwise removed. You have the right, under certain circumstances, to obtain the erasure of your data from us.',

    'Receive your data and have it transferred to another controller. You have the right, under certain circumstances, to receive the data you have provided to us in a structured, commonly used and machine readable format and, if technically feasible, to have it transmitted to another controller without any hindrance.',
  ],
  other_right_last_ele_1:
    'Any requests to exercise your rights can be directed to us by email: ',
  other_right_email: 'legal@olaelectric.com.',
  other_right_last_ele_2:
    "These requests can be exercised free of charge and will be addressed by us as soon as possible and always within one month.'",
};

const PrivacyPolicy = () => {
  //const location = useLocation();
  const [path, setPath] = useState('/');
  //const history = useHistory();
  //const currentLocation = history.location.pathname;
  //console.log('cuurent location si ', currentLocation);
  const [policyOemAndroidIos, setPolicyOemAndroidIos] = useState(false);

  const { search } = useLocation();
  const values = queryString.parse(search);

  let otherParams : Array<string> = [];

  // function getCookie(cname) {
  //   var name = cname + '=';
  //   var decodedCookie = decodeURIComponent(document.cookie);
  //   var ca = decodedCookie.split(';');
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == ' ') {
  //       c = c.substring(1);
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length);
  //     }
  //   }
  //   return '';
  // }

  if (values) {
    Object.keys(values).forEach((key) => {
      const usualUTM = [
        'utm_source',
        'source',
        'utm_medium',
        'medium',
        'campaign',
        'utm_campaign',
      ];
      if (usualUTM.includes(key)) {
        return;
      }

      otherParams = [...otherParams, key];
    });
  }

  let otherParamsVal = {};
  if (otherParams) {
    otherParams.forEach((param) => {
      otherParamsVal = { ...otherParamsVal, [param]: values[param] };
    });
  }

  // const sourceUTM = values.source ? values.source : values.utm_source;
  // const campaignUTM = values.campaign ? values.campaign : values.utm_campaign;
  // const mediumUTM = values.medium ? values.medium : values.utm_medium;

  // let tempUTM = {};

  // if (campaignUTM) {
  //   tempUTM = { ...tempUTM, campaign: campaignUTM };
  // }

  // if (mediumUTM) {
  //   tempUTM = { ...tempUTM, medium: mediumUTM };
  // }



  return (
    <div className="privacy-policy-main">
      <div className="nav_top">{/* <NavbarBlog isBlogBtn={false} /> */}</div>



      <title>Privacy Policy</title>
      <meta name="description" content="***" />

      <div className="privacy-policy">
      {!policyOemAndroidIos && (
        <div className="policy_back_icon">
          <Link to={path}>
            <img src={backIcon} className="back-icon" />
          </Link>
        </div>
      )}
        <Label className="privacy_header" text="Privacy Policy" />
        <div className="privacy-policy-section">
          <Label
            className="safeguard_header"
            text={privacyPolicy.safeguard_heading}
          />

          <div className="safeguard_section">
            <Label
              className="safeguard_points"
              text={privacyPolicy.safeguard_point1}
            />
            <Label
              className="safeguard_points"
              text={privacyPolicy.safeguard_point2}
            />
            <Label
              className="safeguard_points"
              text={privacyPolicy.safeguard_point3}
            />
            <Label
              className="safeguard_points"
              text={privacyPolicy.safeguard_point4}
            />
          </div>
          <Label
            className="information_header"
            text={privacyPolicy.information_header}
          />
          <Label
            className="information_subheader"
            text={privacyPolicy.information_subheader}
          />
          <Label
            className="information_points_title"
            text={privacyPolicy.information_points_title}
          />

          <ul>
            {' '}
            {privacyPolicy.information_bullets_point.map((item) => (
              <li className="information_bullets_point"> {item}</li>
            ))}
          </ul>

          <Label
            className="information_after_1_bullet"
            text={privacyPolicy.information_after_1_bullet}
          />
          <Label
            className="information_2_bullet_title"
            text={privacyPolicy.information_2_bullet_title}
          />

          <ul>
            {' '}
            {privacyPolicy.information_2_bullet_points.map((item) => (
              <li className="information_2_bullet_points"> {item}</li>
            ))}
          </ul>
          <Label
            className="user_account_header"
            text={privacyPolicy.user_account_header}
          />
          <Label
            className="user_account_bullet_title"
            text={privacyPolicy.user_account_bullet_title}
          />
          <ul>
            {' '}
            {privacyPolicy.user_acc_bullet_point.map((item) => (
              <li className="user_acc_bullet_point"> {item}</li>
            ))}
          </ul>
          <Label
            className="user_acc_after_bullet_1"
            text={privacyPolicy.user_acc_after_bullet_1}
          />
          <Label
            className="user_acc_after_bullet_2"
            text={privacyPolicy.user_acc_after_bullet_2}
          />
          <Label
            className="web_app_header"
            text={privacyPolicy.web_app_header}
          />
          <Label className="web_app_text" text={privacyPolicy.web_app_text} />
          <Label
            className="test_ride_header"
            text={privacyPolicy.test_ride_header}
          />
          <Label
            className="test_ride_text"
            text={privacyPolicy.test_ride_text}
          />
          <ul>
            {' '}
            {privacyPolicy.test_ride_bullet_point.map((item) => (
              <li className="test_ride_bullet_point"> {item}</li>
            ))}
          </ul>

          <Label
            className="preorder_purchase_header"
            text={privacyPolicy.preorder_purchase_header}
          />
          <Label
            className="preorder_purchase_text"
            text={privacyPolicy.preorder_purchase_text}
          />
          <Label
            className="preorder_purchase_bullet_title"
            text={privacyPolicy.preorder_purchase_bullet_title}
          />

          <ul>
            {' '}
            {privacyPolicy.preorder_purchase_bullet_points.map((item) => (
              <li className="preorder_purchase_bullet_points"> {item}</li>
            ))}
          </ul>
          <Label
            className="driving_header"
            text={privacyPolicy.driving_header}
          />
          <Label className="driving_text1" text={privacyPolicy.driving_text1} />
          <Label className="driving_text2" text={privacyPolicy.driving_text2} />
          <Label className="driving_text3" text={privacyPolicy.driving_text3} />
          <Label className="driving_text4" text={privacyPolicy.driving_text4} />
          <Label className="driving_text5" text={privacyPolicy.driving_text5} />

          <Label
            className="use_of_collection_header"
            text={privacyPolicy.use_of_collection_header}
          />
          {privacyPolicy.use_of_collection_bullet_points.map((item) => (
            <Label className="user_acc_bullet_point" text={item} />
          ))}

          <Label
            className="retension_header"
            text={privacyPolicy.retension_header}
          />
          <Label
            className="retension_text1"
            text={privacyPolicy.retension_text1}
          />

          <Label
            className="sharing_header"
            text={privacyPolicy.sharing_header}
          />

          {privacyPolicy.sharing_data.map((item, index) => (
            <>
              {' '}
              {index != 1 && index != 3 && index != 5 && index != 6 && (
                <Label
                  className={`sharing_data sharing_data_${index}`}
                  text={item}
                />
              )}
              {index === 1 && <Label className="reduce_space" text={item} />}
              {index === 3 && <Label className="reduce_space" text={item} />}
              {index === 5 && <Label className="reduce_space" text={item} />}
              {index === 6 && <Label className="reduce_space" text={item} />}
            </>
          ))}
          <Label
            className="sharing_bullet_title"
            text={privacyPolicy.sharing_bullet_title}
          />
          <ul>
            {' '}
            {privacyPolicy.sharing_bullet_points.map((item) => (
              <li className="sharing_bullet_points"> {item}</li>
            ))}
          </ul>
          <Label
            className="sharing_last_text"
            text={privacyPolicy.sharing_last_text}
          />

          <Label
            className="thirdparty_header"
            text={privacyPolicy.thirdparty_header}
          />

          <Label
            className="thirdparty_text"
            text={privacyPolicy.thirdparty_text}
          />

          <Label
            className="social_media_header"
            text={privacyPolicy.social_media_header}
          />
          <Label
            className="social_media_text"
            text={privacyPolicy.social_media_text}
          />
          <Label
            className="security_header"
            text={privacyPolicy.security_header}
          />
          <Label className="security_text" text={privacyPolicy.security_text} />
          <Label
            className="change_policy_header"
            text={privacyPolicy.change_policy_header}
          />
          <Label
            className="change_policy_text"
            text={privacyPolicy.change_policy_text}
          />
          <Label className="gre_header" text={privacyPolicy.gre_header} />
          <p className="text-wrapper gre_text">
            {privacyPolicy.gre_text}
            <span className="other_right_email">
              {privacyPolicy.gre_text_email}
            </span>
          </p>

          <Label className="other_rights" text={privacyPolicy.other_rights} />

          {privacyPolicy.other_right_data.map((item) => (
            <Label className="other_right_data" text={item} />
          ))}

          <p className="text-wrapper other_right_data">
            {privacyPolicy.other_right_last_ele_1}
            <span className="other_right_email">
              {privacyPolicy.other_right_email}{' '}
            </span>
            {privacyPolicy.other_right_last_ele_2}
          </p>
        </div>

        <div style={{ marginTop: '83px', backgroundColor: '#ffffff' }}></div>
      </div>
      {/* <BlogFooter linkPath="/policy"/> */}
    </div>
  );
};

export default PrivacyPolicy;
